import { i18n } from "@/i18n";
export const startTour = async ({ context, tourType = "user" }) => {
  try {
    const { driver } = await import("driver.js");

    // Pasos Comunes para TODOS los tours
    const commonSteps = [
      {
        element: "#left-rectangle",
        popover: {
          title: i18n.t('tour.project_title'),
          description: i18n.t('tour.project_description'),
          position: "bottom",
        },
      },
      {
        element: "#right-rectangle",
        popover: {
          title: i18n.t('tour.help_title'),
          description: i18n.t('tour.help_description'),
          position: "bottom",
        },
      },
      {
        element: ".content-canvas",
        popover: {
          title: i18n.t('tour.canvas_title'),
          description: i18n.t('tour.canvas_description'),
          position: "right",
        },
      },
      {
        element: "#tool-menu",
        popover: {
          title: i18n.t('tour.toolbar_title'),
          description: i18n.t('tour.toolbar_description'),
          position: "bottom",
          onNextClick: () => {
            context.toggleSidebar("sidebar-components");
            tour.moveNext();
          },
        },
      },
      {
        element: "#sidebar-wrapper",
        popover: {
          title: i18n.t('tour.components_title'),
          description: i18n.t('tour.components_description'),
          position: "right",
        },
        onDeselected: () => {
          context.toggleSidebar("sidebar-components");
        },
      },
      {
        element: "#code-icon",
        popover: {
          title: i18n.t('tour.editor_button_title'),
          description: i18n.t('tour.editor_button_description'),
          position: "bottom",
          onNextClick: async () => {
            context.$nextTick(() => {
              context.selectButton("programming");
              context.toggleSidebar("sidebar-right-programming");
            });
            await context.$nextTick();
            tour.moveNext();
          },
          onPrevClick: () => {
            context.toggleSidebar("sidebar-components");
            tour.movePrevious();
          },
        },
      },
      {
        element: "#code-editor",
        popover: {
          title: i18n.t('tour.editor_panel_title'),
          description: i18n.t('tour.editor_panel_description'),
          position: "left",
        },
        onDeselected: () => {
          context.toggleSidebar("sidebar-right-programming");
        },
      },
    ];

    // Pasos para la vista de Academia (compartidos por Estudiante y Profesor)
    const activitySharedSteps = [
      {
        element: "#sidebar-btn-instructions",
        popover: {
          title: i18n.t('tour.guide_button_title'),
          description: i18n.t('tour.guide_button_description'),
          position: "bottom",
          onNextClick: async () => {
            context.$nextTick(() => {
              context.toggleSidebarInstructions();
            });
            await context.$nextTick();
            tour.moveNext();
          },
          onPrevClick: () => {
            context.toggleSidebar("sidebar-right-programming");
            tour.movePrevious();
          },
        },
      },
      {
        element: ".right-sidebar",
        popover: {
          title: i18n.t('tour.guide_panel_title'),
          description: i18n.t('tour.guide_panel_description'),
          position: "left",
        },
        onDeselected: () => {
          context.toggleSidebarInstructions();
        },
      },
    ];

    const studentSteps = [];

    const tutorSteps = [
      {
        element: "#keyboard-icon",
        popover: {
          title: i18n.t('tour.keyboard_control_title'),
          description: i18n.t('tour.keyboard_control_description'),
          position: "right",
        },
      },
      {
        element: "#dropdown-activity",
        popover: {
          title: i18n.t('tour.view_switcher_title'),
          description: i18n.t('tour.view_switcher_description'),
          position: "bottom",
        },
      },
    ];

    const userSteps = [
      {
        popover: {
          title: i18n.t('tour.congratulations_title'),
          description: i18n.t('tour.congratulations_description'),
          position: "top",
          onPrevClick: async () => {
            context.$nextTick(() => {
              context.selectButton("programming");
              context.toggleSidebar("sidebar-right-programming");
            });
            await context.$nextTick();
            tour.movePrevious();
          },
        },
      },
    ];

    const adminSteps = [
      {
        element: "#sidebar-btn-instructions",
        popover: {
          title: i18n.t('tour.guide_button_title'),
          description: i18n.t('tour.guide_button_description'),
          position: "bottom",
          onNextClick: async () => {
            context.$nextTick(() => {
              context.toggleSidebarInstructions();
            });
            await context.$nextTick();
            tour.moveNext();
          },
          onPrevClick: () => {
            context.toggleSidebar("sidebar-right-programming");
            tour.movePrevious();
          },
        },
      },
      {
        element: ".right-sidebar",
        popover: {
          title: i18n.t('tour.guide_panel_title'),
          description: i18n.t('tour.guide_panel_description_editor'),
          position: "left",
        },
        onDeselected: () => {
          context.toggleSidebarInstructions();
        },
      },
    ];
    // Pasos para la vista de Academia (compartidos por Template y Practical Guide)
    const templateSharedSteps = [
      {
        element: "#sidebar-btn-instructions",
        popover: {
          title: i18n.t('tour.guide_button_title'),
          description: i18n.t('tour.access_instructions'),
          position: "bottom",
          onNextClick: async () => {
            context.$nextTick(() => {
              context.toggleSidebarInstructions();
            });
            await context.$nextTick();
            tour.moveNext();
          },
          onPrevClick: () => {
            context.toggleSidebar("sidebar-right-programming");
            tour.movePrevious();
          },
        },
      },
      {
        element: ".right-sidebar",
        popover: {
          title: i18n.t('tour.guide_panel_title'),
          description: i18n.t('tour.guide_panel_description'),
          position: "left",
        },
        onDeselected: () => {
          context.toggleSidebarInstructions();
        },
      },
    ];
    const practicalGuideSteps = [
      {
        element: "#dropdown-activity",
        popover: {
          title: i18n.t('tour.view_switcher_title'),
          description: i18n.t('tour.view_switcher_description'),
          position: "bottom",
        },
      },
    ];
    // Paso final
    const finalStep = [
      {
        popover: {
          title: i18n.t('tour.congratulations_title'),
          description: i18n.t('tour.congratulations_description'),
          position: "top",
          onPrevClick: async () => {
            context.$nextTick(() => {
              context.toggleSidebarInstructions();
            });
            await context.$nextTick();
            tour.movePrevious();
          },
        },
      },
    ];

    // CONSTRUCCIÓN DINÁMICA DE LOS PASOS
    let steps = [];

    switch (tourType) {
      case "student":
        steps = [
          ...commonSteps,
          ...activitySharedSteps,
          ...studentSteps,
          ...finalStep,
        ];
        break;
      case "tutor":
        steps = [
          ...commonSteps,
          ...activitySharedSteps,
          ...tutorSteps,
          ...finalStep,
        ];
        break;
      case "admin":
        steps = [...commonSteps, ...adminSteps, ...finalStep];
        break;
      case "template":
        steps = [...commonSteps, ...templateSharedSteps, ...finalStep];
        break;
      case "practical-guide":
        steps = [
          ...commonSteps,
          ...templateSharedSteps,
          ...practicalGuideSteps,
          ...finalStep,
        ];
        break;
      case "user":
      default:
        steps = [...commonSteps, ...userSteps];
        break;
    }

    const tour = driver({
      nextBtnText: `${i18n.t('tour.btn_next')} →`,
      prevBtnText: `← ${i18n.t('tour.btn_previous')}`,
      doneBtnText: i18n.t('tour.btn_done'),
      showProgress: true,
      steps,
    });

    tour.drive();
  } catch (error) {
    console.error("Error al iniciar el tour:", error);
  }
};
